import { registerPlugin } from '@capacitor/core';
const CapacitorCustomGoogleMaps = registerPlugin('CapacitorCustomGoogleMaps', {
    web: () => import('./web').then(m => new m.CapacitorCustomGoogleMapsWeb()),
});
CapacitorCustomGoogleMaps.addListener('isMapInFocus', data => {
    var _a;
    const x = data.x;
    const y = data.y;
    const elem = document.elementFromPoint(x, y);
    const internalId = (_a = elem === null || elem === void 0 ? void 0 : elem.dataset) === null || _a === void 0 ? void 0 : _a.internalId;
    const mapInFocus = internalId === data.mapId;
    CapacitorCustomGoogleMaps.dispatchMapEvent({ id: data.mapId, focus: mapInFocus });
});
export { CapacitorCustomGoogleMaps };
//# sourceMappingURL=implementation.js.map